/*
  © 2025 KondaSoft — Phase 2: Confirm flow, color swatches, edit accordion
*/

class CrossSells extends HTMLElement {
  constructor() {
    super();

    // Confirmed selections: { handle: { variantId, colorHandle, sizeName, productTitle } }
    this.confirmedSelections = {};

    this.atcButton = this.querySelector('button[name="cross-sells-atc"]');
    this.atcButton.addEventListener("click", this.addToCart.bind(this));

    this.querySelectorAll(".cross-sells-secondary-list input[type='checkbox']").forEach((checkbox, index) => {
      checkbox.addEventListener("change", () => {
        this.querySelector(`.cross-sells-list-images-item:nth-child(${index + 1}) .cross-sells-list-images-item-inner`).classList.toggle("active", checkbox.checked);
        this.handleLogic();
      });
    });

    this.querySelectorAll(".cross-sells-secondary-list select").forEach((select, index) => {
      select.addEventListener("change", () => {
        const selectedOption = select.options[select.selectedIndex];

        const variantImage = selectedOption.dataset.variantImage;
        if (variantImage && variantImage.length) {
          const productImage = this.querySelector(`.cross-sells-list-images-item:nth-child(${index + 1}) img`);
          if (productImage) productImage.src = variantImage;
        }

        const variantComparePrice = selectedOption.dataset.variantComparePrice;
        const variantPrice = selectedOption.dataset.variantPrice;

        const listItem = select.closest(".cross-sells-secondary-list-item");
        if (listItem) {
          const cb = listItem.querySelector("input[type='checkbox']");
          if (cb) cb.value = selectedOption.value;
          const priceCompare = listItem.querySelector("[data-price-compare]");
          const priceSale = listItem.querySelector("[data-price-sale]");
          const priceRegular = listItem.querySelector("[data-price-regular]");
          if (priceCompare) priceCompare.textContent = window.Shopify.formatMoney(variantComparePrice);
          if (priceSale) priceSale.textContent = window.Shopify.formatMoney(variantPrice);
          if (priceRegular) priceRegular.textContent = window.Shopify.formatMoney(variantPrice);
        }

        this.handleLogic();
      });
    });

    this.adjustLayout();
    this.initCollapsibleList();
    this.initFbtOverlay();
  }

  handleLogic() {
    const checkedCheckboxes = this.getCheckedCheckboxes();

    let totalComparePrice = Array.from(checkedCheckboxes).reduce((sum, checkbox) => {
      return sum + Number(checkbox.dataset.comparePrice);
    }, 0);

    let totalPrice = Array.from(checkedCheckboxes).reduce((sum, checkbox) => {
      return sum + Number(checkbox.dataset.price);
    }, 0);

    const discount = Number(this.dataset.discount);
    const discountMinItems = Number(this.dataset.discountMinItems);

    if (discount > 0 && checkedCheckboxes.length >= discountMinItems) {
      totalPrice = ((100 - discount) / 100) * totalPrice;
    }

    const totalCompareEl = this.querySelector("[data-total-compare-price]");
    const totalPriceEl = this.querySelector("[data-total-price]");
    const totalSavingsEl = this.querySelector("[data-total-savings]");

    if (totalCompareEl) totalCompareEl.textContent = window.Shopify.formatMoney(totalComparePrice);
    if (totalPriceEl) totalPriceEl.textContent = window.Shopify.formatMoney(totalPrice);
    if (totalSavingsEl) totalSavingsEl.textContent = `${window.Shopify.formatMoney(totalComparePrice - totalPrice)} (${Math.round((1 - totalPrice / totalComparePrice) * 100 || 0)}%)`;

    const discountAlert = this.querySelector(".cross-sells-footer-discount");
    if (discountAlert) {
      discountAlert.setAttribute("data-alert-type", checkedCheckboxes.length >= discountMinItems ? "success" : "warning");
    }

    this.querySelector(".btn-atc").disabled = checkedCheckboxes.length === 0;
  }

  getCheckedCheckboxes() {
    return this.querySelectorAll(".cross-sells-secondary-list input[type='checkbox']:checked");
  }

  adjustLayout() {
    const task = () => {
      const footer = this.querySelector(".cross-sells-footer");
      if (!footer) return;
      if (window.matchMedia("(max-width: 1199px)").matches) {
        const secondaryList = this.querySelector(".cross-sells-secondary-list");
        if (secondaryList) secondaryList.insertAdjacentElement("afterend", footer);
      } else {
        const imageList = this.querySelector(".cross-sells-list-images");
        if (imageList) imageList.insertAdjacentElement("afterend", footer);
      }
    };
    task();
    window.addEventListener("resize", task);
    window.addEventListener("orientationchange", task);
  }

  initCollapsibleList() {
    const toggle = this.querySelector('.cross-sells-details-toggle');
    const list = this.querySelector('.cross-sells-secondary-list');
    if (!toggle || !list) return;

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      list.hidden = expanded;
    });
  }

  initFbtOverlay() {
    const modal = this.querySelector('.fbt-modal');
    if (!modal) return;

    const backdrop = modal.querySelector('.fbt-modal-backdrop');
    const closeBtn = modal.querySelector('.fbt-modal-close');
    const productNameEl = modal.querySelector('.fbt-modal-product-name');
    const priceEl = modal.querySelector('.fbt-modal-price');
    const swatchesWrap = modal.querySelector('.fbt-modal-swatches');
    const loadingEl = modal.querySelector('.fbt-modal-loading');
    const variantOptions = modal.querySelector('.fbt-variant-options');
    const errorEl = modal.querySelector('.fbt-modal-error');
    const confirmBtn = modal.querySelector('.fbt-modal-confirm-btn');

    let selectedVariantId = null;
    let currentHandle = null;
    let currentProductData = null;
    let currentOriginalHandle = null;

    const moneyFormat = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try { return window.Shopify.formatMoney(cents); } catch(e) {}
      }
      return '$' + (cents / 100).toFixed(2);
    };

    const openModal = () => {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    };

    const closeModal = () => {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      selectedVariantId = null;
      currentHandle = null;
      currentProductData = null;
      variantOptions.innerHTML = '';
      if (swatchesWrap) swatchesWrap.innerHTML = '';
      if (errorEl) errorEl.hidden = true;
    };

    if (backdrop) backdrop.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    const setLoading = (loading) => {
      if (loadingEl) loadingEl.hidden = !loading;
      if (variantOptions) variantOptions.style.display = loading ? 'none' : '';
    };

    const buildVariantButtons = (variants) => {
      variantOptions.innerHTML = '';
      selectedVariantId = null;
      if (errorEl) errorEl.hidden = true;

      (variants || []).forEach((v) => {
        const vBtn = document.createElement('button');
        vBtn.type = 'button';
        vBtn.className = 'fbt-variant-btn';
        vBtn.textContent = v.title;
        vBtn.disabled = !v.available;
        vBtn.dataset.variantId = v.id;
        vBtn.addEventListener('click', () => {
          variantOptions.querySelectorAll('.fbt-variant-btn').forEach(b => b.classList.remove('is-selected'));
          vBtn.classList.add('is-selected');
          selectedVariantId = v.id;
          if (errorEl) errorEl.hidden = true;
        });
        variantOptions.appendChild(vBtn);
      });
    };

    const loadProductForModal = async (handle) => {
      setLoading(true);
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error('fetch failed');
        currentProductData = await res.json();
        currentHandle = handle;

        if (productNameEl) productNameEl.textContent = currentProductData.title || '';
        if (priceEl) {
          const p = currentProductData.price || 0;
          const c = currentProductData.compare_at_price || 0;
          if (c > p) {
            priceEl.innerHTML = `<span class="fbt-price fbt-price--sale">${moneyFormat(p)}</span> <span class="fbt-price fbt-price--compare">${moneyFormat(c)}</span>`;
          } else {
            priceEl.textContent = moneyFormat(p);
          }
        }

        buildVariantButtons(currentProductData.variants || []);

        // If we have a previous selection for this handle, re-select it
        const prevSelection = this.confirmedSelections[currentOriginalHandle];
        if (prevSelection && prevSelection.colorHandle === handle && prevSelection.variantId) {
          const prevBtn = variantOptions.querySelector(`[data-variant-id="${prevSelection.variantId}"]`);
          if (prevBtn && !prevBtn.disabled) {
            prevBtn.classList.add('is-selected');
            selectedVariantId = prevSelection.variantId;
          }
        }
      } catch (_) {
        if (productNameEl) productNameEl.textContent = 'Failed to load product';
      } finally {
        setLoading(false);
      }
    };

    const colourSection = modal.querySelector('.fbt-modal-section--colour');
    const sizeSection = modal.querySelector('.fbt-modal-section--size');

    const loadSwatches = async (handle) => {
      if (!swatchesWrap) return;
      swatchesWrap.innerHTML = '';
      // Hide colour section by default, show only if swatches exist
      if (colourSection) colourSection.style.display = 'none';

      try {
        const res = await fetch(`/products/${handle}?view=color-family-json`);
        if (!res.ok) return;
        const text = await res.text();
        let swatches = [];
        try { swatches = JSON.parse(text); } catch(_) { return; }
        if (!Array.isArray(swatches) || swatches.length <= 1) return;

        // Show the colour section since we have swatches
        if (colourSection) colourSection.style.display = '';

        swatches.forEach(s => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'fbt-swatch-dot' + (s.active ? ' is-active' : '');
          dot.style.setProperty('--swatch-color', s.hex || '#ccc');
          dot.setAttribute('aria-label', s.name || 'Color');
          dot.dataset.swatchHandle = s.handle;

          dot.addEventListener('click', async () => {
            swatchesWrap.querySelectorAll('.fbt-swatch-dot').forEach(d => d.classList.remove('is-active'));
            dot.classList.add('is-active');
            await loadProductForModal(s.handle);
          });

          swatchesWrap.appendChild(dot);
        });
      } catch (_) {}
    };

    // Wire up the plus buttons
    this.querySelectorAll('.fbt-add-btn').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const handle = btn.dataset.productHandle;
        const title = btn.dataset.productTitle || '';

        currentOriginalHandle = handle;

        if (productNameEl) productNameEl.textContent = title;
        variantOptions.innerHTML = '';
        if (swatchesWrap) swatchesWrap.innerHTML = '';
        if (errorEl) errorEl.hidden = true;
        selectedVariantId = null;

        openModal();

        // Load color swatches and product data in parallel
        await Promise.all([
          loadSwatches(handle),
          loadProductForModal(handle)
        ]);
      });
    });

    // Confirm button — save selection and close modal (no cart add)
    if (confirmBtn) {
      confirmBtn.addEventListener('click', () => {
        if (!selectedVariantId) {
          if (errorEl) errorEl.hidden = false;
          return;
        }

        const selectedBtn = variantOptions.querySelector('.fbt-variant-btn.is-selected');
        const sizeName = selectedBtn ? selectedBtn.textContent : '';

        // Save the confirmed selection (include image + price for grid sync)
        this.confirmedSelections[currentOriginalHandle] = {
          variantId: selectedVariantId,
          colorHandle: currentHandle,
          sizeName: sizeName,
          productTitle: currentProductData ? currentProductData.title : '',
          featuredImage: currentProductData ? currentProductData.featured_image : '',
          price: currentProductData ? currentProductData.price : 0,
          compareAtPrice: currentProductData ? (currentProductData.compare_at_price || 0) : 0
        };

        // Update the accordion list item to show confirmed state
        this._updateAccordionItem(currentOriginalHandle);

        // Sync checkbox
        this._syncCheckbox(currentOriginalHandle, selectedVariantId);

        closeModal();
      });
    }
  }

  _updateAccordionItem(originalHandle) {
    const selection = this.confirmedSelections[originalHandle];
    if (!selection) return;

    const moneyFormat = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try { return window.Shopify.formatMoney(cents); } catch(e) {}
      }
      return '$' + (cents / 100).toFixed(2);
    };

    const allBtns = this.querySelectorAll('.fbt-add-btn');
    let matchIndex = -1;
    allBtns.forEach((btn, idx) => {
      if (btn.dataset.productHandle === originalHandle) matchIndex = idx;
    });

    if (matchIndex < 0) return;

    // 1) Update the FBT IMAGE GRID — swap the product image to the new color
    if (selection.featuredImage) {
      const gridImage = this.querySelector(`.cross-sells-list-images-item:nth-child(${matchIndex + 1}) img`);
      if (gridImage) gridImage.src = selection.featuredImage;
    }

    // 2) Update the FBT GRID PRICE below the image
    const gridPriceEl = this.querySelector(`.cross-sells-list-images-item:nth-child(${matchIndex + 1}) .fbt-product-price`);
    if (gridPriceEl) {
      if (selection.compareAtPrice && selection.compareAtPrice > selection.price) {
        gridPriceEl.innerHTML = `<span class="fbt-price fbt-price--sale">${moneyFormat(selection.price)}</span> <span class="fbt-price fbt-price--compare">${moneyFormat(selection.compareAtPrice)}</span>`;
      } else {
        gridPriceEl.innerHTML = `<span class="fbt-price">${moneyFormat(selection.price)}</span>`;
      }
    }

    // 3) Update the ACCORDION LIST ITEM — change product name in the label
    const listItem = this.querySelector(`.cross-sells-secondary-list-item:nth-child(${matchIndex + 1})`);
    if (!listItem) return;

    const labelSpan = listItem.querySelector('.check-label > span.fs-md');
    if (labelSpan) {
      // Preserve "This item:" prefix for first item
      const isFirst = matchIndex === 0;
      const prefix = isFirst ? "This item: " : "";
      labelSpan.textContent = prefix + selection.productTitle;
    }

    // 4) Show confirmed size below the product name (replaces old confusing extra line)
    let infoEl = listItem.querySelector('.fbt-confirmed-info');
    if (!infoEl) {
      infoEl = document.createElement('div');
      infoEl.className = 'fbt-confirmed-info';
      listItem.appendChild(infoEl);
    }

    infoEl.innerHTML = '';
    const text = document.createElement('span');
    text.className = 'fbt-confirmed-text';
    text.textContent = `Size: ${selection.sizeName}`;
    infoEl.appendChild(text);

    const editBtn = document.createElement('button');
    editBtn.type = 'button';
    editBtn.className = 'fbt-edit-btn';
    editBtn.textContent = 'Edit';
    editBtn.addEventListener('click', () => {
      const addBtn = this.querySelectorAll('.fbt-add-btn')[matchIndex];
      if (addBtn) addBtn.click();
    });
    infoEl.appendChild(editBtn);

    // 5) Update the accordion price
    const priceSale = listItem.querySelector('[data-price-sale]');
    const priceRegular = listItem.querySelector('[data-price-regular]');
    const priceCompare = listItem.querySelector('[data-price-compare]');
    const priceWrapper = listItem.querySelector('.product-card-price');

    if (priceSale) priceSale.textContent = moneyFormat(selection.price);
    if (priceRegular) priceRegular.textContent = moneyFormat(selection.price);
    if (priceCompare) priceCompare.textContent = moneyFormat(selection.compareAtPrice);
    if (priceWrapper) {
      priceWrapper.setAttribute('data-has-price-compare',
        (selection.compareAtPrice && selection.compareAtPrice > selection.price) ? 'true' : 'false'
      );
    }
  }

  _syncCheckbox(originalHandle, variantId) {
    const selection = this.confirmedSelections[originalHandle];
    const allBtns = this.querySelectorAll('.fbt-add-btn');
    let matchIndex = -1;
    allBtns.forEach((btn, idx) => {
      if (btn.dataset.productHandle === originalHandle) matchIndex = idx;
    });

    if (matchIndex < 0) return;

    const listItem = this.querySelector(`.cross-sells-secondary-list-item:nth-child(${matchIndex + 1})`);
    if (!listItem) return;

    const checkbox = listItem.querySelector("input[type='checkbox']");
    if (checkbox) {
      checkbox.value = variantId;
      // Update price data attributes so totals recalculate correctly
      if (selection) {
        checkbox.dataset.price = String(selection.price || 0);
        checkbox.dataset.comparePrice = String(selection.compareAtPrice || 0);
      }
      if (!checkbox.checked) {
        checkbox.checked = true;
      }
      // Always dispatch change to recalculate totals
      checkbox.dispatchEvent(new Event('change'));
    }

    const select = listItem.querySelector('select');
    if (select) {
      const option = select.querySelector(`option[value="${variantId}"]`);
      if (option) {
        select.value = String(variantId);
        select.dispatchEvent(new Event('change'));
      }
    }
  }

  async addToCart(event) {
    event.preventDefault();

    const checkedCheckboxes = this.getCheckedCheckboxes();
    const selectedVariants = Array.from(checkedCheckboxes).map((checkbox) => Number(checkbox.value));

    if (selectedVariants.length === 0) return;

    this.atcButton.classList.add("loading");
    this.atcButton.disabled = true;
    this.atcButton.setAttribute("aria-busy", "true");

    const items = selectedVariants.map((variantId) => ({
      id: variantId,
      quantity: 1,
    }));

    try {
      const cartComponent = document.querySelector("cart-component");
      if (cartComponent && typeof cartComponent.add === 'function') {
        await cartComponent.add({ items });
      } else {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) throw new Error('add failed');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (_) {
      alert('Could not add to cart. Please try again.');
    }

    this.atcButton.classList.remove("loading");
    this.atcButton.disabled = false;
    this.atcButton.setAttribute("aria-busy", "false");
  }
}
customElements.define("cross-sells", CrossSells);
